import type { memberPaymentMethodListItem } from '@/api'
import { PayMethod } from '@/enums'

const PAY_METHOD_ORDER = [PayMethod.BANKCARD, PayMethod.ALIPAY, PayMethod.WEPAY, PayMethod.ECNY]
export const paymentSortFn = (a: memberPaymentMethodListItem, b: memberPaymentMethodListItem) => {
  if (a.method === b.method) {
    return 0
  }
  const ai = PAY_METHOD_ORDER.indexOf(a.method as PayMethod)
  const bi = PAY_METHOD_ORDER.indexOf(b.method as PayMethod)
  const an = ai === -1 ? PAY_METHOD_ORDER.length : ai
  const bn = bi === -1 ? PAY_METHOD_ORDER.length : bi
  return an - bn
}

/** 补充至两位小数 */
export const pad2decimal = (num: number | string) => {
  return Number(num).toFixed(2)
}
